import axios, { AxiosError, AxiosResponse } from 'axios'

import { axiosInstance } from './axios'

const addContentTypeHeader = (contentType?: string) => {
  return {
    'Content-Type': contentType || 'application/json',
  }
}

// eslint-disable-next-line
const handleResponse = <T>(response: AxiosResponse<T, any>): T | Error => {
  if (response.status === 200 || response.status === 201) {
    return response.data
  } else {
    return new Error('respose status is not 200 or 201')
  }
}

const handleError = (error: unknown): AxiosError | Error => {
  console.error('API Error:', error)
  if (axios.isAxiosError(error)) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('handleError:', error)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest
      console.error('handleError:', error)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('handleError:', error)
    }

    throw error
  } else {
    // different error than axios
    console.error('handleError:', error)
    throw new Error('Non-axios error')
  }
}

const getRequest = async (
  url: string,
  // eslint-disable-next-line
): Promise<Record<string, any> | (AxiosError | Error)> => {
  try {
    return await axiosInstance({
      url: url,
      method: 'GET',
      headers: addContentTypeHeader(),
    }).then((response: AxiosResponse) => handleResponse(response))
  } catch (error) {
    return handleError(error)
  }
}

const postRequest = async (
  url: string,
  // eslint-disable-next-line
  body?: Record<string, any>,
  isFormData?: boolean,
  config: Record<string, any> = {},
  // eslint-disable-next-line
): Promise<any | (AxiosError | Error)> => {
  try {
    return await axiosInstance({
      url: url,
      method: 'POST',
      data: body,
      headers: isFormData
        ? addContentTypeHeader('multipart/form-data')
        : addContentTypeHeader(),
      ...config,
    }).then((response: AxiosResponse) => handleResponse(response))
  } catch (error) {
    return handleError(error)
  }
}

const putRequest = async (
  url: string,
  // eslint-disable-next-line
  body?: Record<string, any>,
  // eslint-disable-next-line
): Promise<Record<string, any> | (AxiosError | Error)> => {
  try {
    return await axiosInstance({
      url: url,
      method: 'PUT',
      data: body,
      headers: addContentTypeHeader(),
    }).then((response: AxiosResponse) => handleResponse(response))
  } catch (error) {
    return handleError(error)
  }
}

const deleteRequest = async (
  url: string,
  // eslint-disable-next-line
  body?: Record<string, any>,
  // eslint-disable-next-line
): Promise<Record<string, any> | (AxiosError | Error)> => {
  try {
    return await axiosInstance({
      url: url,
      method: 'DELETE',
      data: body,
      headers: addContentTypeHeader(),
    }).then((response: AxiosResponse) => handleResponse(response))
  } catch (error) {
    return handleError(error)
  }
}

export const ApiProvider = {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
}
